import { render } from "./CartFooter.vue?vue&type=template&id=534809e7&scoped=true"
import script from "./CartFooter.vue?vue&type=script&lang=js"
export * from "./CartFooter.vue?vue&type=script&lang=js"

import "./CartFooter.vue?vue&type=style&index=0&id=534809e7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-534809e7"

export default script